import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { UserMenuModule } from '@epicuro-next/features/user-menu';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';

import { SiteSelectorComponent } from './containers/site-selector/site-selector.component';
import { SiteSelectorModule } from './site-selector.module';

@NgModule({
  imports: [
    SiteSelectorModule,
    CommonModule,
    StateSitesStateModule,
    RouterModule.forChild([
      {
        path: ':siteId',
        component: SiteSelectorComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        component: SiteSelectorComponent,
      },
    ]),
    LoaderOverlayModule,
    ImageModule,
    UserMenuModule,
  ],
  declarations: [SiteSelectorComponent],
  exports: [SiteSelectorComponent],
})
export class FeaturesSiteSelectorModule {}
